import { TripForDriverOutput } from '@allocab/allocab-driver-shared-types';

import { useDriverOptions } from '../../services/driver-options/useDriverOptions';
import { formatPriceByOptions, formatPriceOptions } from '../../utils/price';

type Props = {
  trip: TripForDriverOutput;
};

export const TripPrice = ({ trip }: Props) => {
  const { driverOptions } = useDriverOptions();

  return (
    <div className="flex items-baseline lg:flex-col lg:gap-0 lg:items-start font-bold flex-row gap-1">
      <p>{formatPriceByOptions(driverOptions, trip.resume.buyPrice, trip.resume.netBuyPrice)}</p>
      <p className="text-[10px] opacity-50 font-normal">{formatPriceOptions(driverOptions)}</p>
    </div>
  );
};
